export const initContentScrollTo = () => {
  const sections = [...document.querySelectorAll('.js-scroll-to')]
  if (sections.length <= 0) { return false }

  sections.forEach(section => {
    new Tabs(section)
  })
}

class Tabs {
  constructor (section) {
    this.section = section
    this.tabs = [...section.querySelectorAll('.js-tab')]
    this.blocks = [...section.querySelectorAll('.js-block')]

    this.blocks = []
    Array.from(section.querySelectorAll('.js-block')).forEach((block, index) => {
      this.blocks.push({
        el: block,
        ratio: 0,
        visible: false,
        tab: this.tabs[index]
      })
    })

    this.init()
  }

  createObserver () {
    const threshold = []

    for (let i = 0; i <= 1.0; i += 0.01) {
      threshold.push(parseFloat(i.toFixed(2)))
    }

    this.observer = new window.IntersectionObserver(entries => {
      entries.forEach(entry => {
        this.blocks.forEach(block => {
          if (block.el === entry.target) {
            if (entry.isIntersecting) {
              block.ratio = parseFloat(entry.intersectionRect.height / window.innerHeight)
              block.visible = true
            } else {
              block.ratio = 0
              block.visible = false
            }
          }
        })
      })

      this.tabs.forEach(tab => { tab.classList.remove('is-active') })
      const blocks = this.blocks.filter(block => { return block.visible })

      if (blocks.length > 0) {
        blocks.sort((a, b) => b.ratio - a.ratio)
        blocks[0].tab.classList.add('is-active')
      }
    }, { threshold })

    this.blocks.forEach(block => {
      this.observer.observe(block.el)
    })
  }

  bindClicks () {
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        const offset = window.innerWidth < 800 ? 90 : 30

        window.scrollTo({
          left: 0,
          top: window.scrollY + this.blocks[index].el.getBoundingClientRect().top - document.querySelector('header').getBoundingClientRect().height - offset,
          behavior: 'smooth'
        })
      })
    })
  }

  init () {
    this.createObserver()
    this.bindClicks()
  }
}
